module.exports = __webpack_public_path__ + "fonts/Eva-Icons.2f2b9626.woff";